import React, { useState, useEffect, useRef } from "react";
import "../styles/AITools.css";
import { auth } from "../firebaseConfig";
import AIImage1 from "../assets/AI1.png";
import rightArrow from "../assets/rightArrow.png";
import rightArrow1 from "../assets/rightArrowmove.png";
import { useNavigate } from "react-router-dom";

const AITools = () => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const [User, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        console.log("No user logged in");
      }
    });

    return () => unsubscribe();
  }, []);

  const goToNewPage = () => {
    if (User) {
      navigate("/process");
    } else {
      navigate("/signin");
    }
    console.log(prompt);
  };

  const scrollToNextColumn = (index) => {
    const container = scrollContainerRef.current;
    const columnWidth = container.children[0].offsetWidth;
    container.scrollTo({
      left: columnWidth * (index + 1),
      behavior: "smooth",
    });
  };

  return (
    <div className="ai-tools-container">
      <div className="review-header">
        <div className="line-image"></div>
        <h1 className="what-title">What we do</h1>
        <div className="line-image"></div>
      </div>
      <h2 className="feature-heading">Generate Images</h2>
      <p className="ai-paragraph">
        Ignite your creative spark with Imagine AI Image Generator. Describe
        your <br /> vision with words, and watch the powerful tool translate
        them into captivating <br /> artwork. Catalyze a flurry of ideas and
        conquer creative roadblocks.
      </p>
      <div className="columns-container" ref={scrollContainerRef}>
        <div className="column">
          <img src={AIImage1} alt="AIImage1" className="column-image" />
          <div className="column-content">
            <h2>Text to Image</h2>
            <p className="ai-paragraph">
              Witness your ideas blended with Imagine AI Image Generator as
              Real-Time Generation lets you sketch and see your creation come to
              life before your eyes. Refine as you go for a seamless experience.
            </p>
            <button className="try-button" onClick={goToNewPage}>
              <img src={rightArrow} alt="Icon" className="button-icon" />
              Try It Now
            </button>
            <img
              src={rightArrow1}
              alt="Scroll Right"
              className="right-arrow"
              onClick={() => scrollToNextColumn(0)}
            />
          </div>
        </div>

        <div className="column">
          <img src={AIImage1} alt="AIImage2" className="column-image" />
          <div className="column-content">
            <h2>Image Upscale</h2>
            <p className="ai-paragraph">
              Elevate your image quality effortlessly with Imagine AI's Creative
              Upscaler. Watch as blurry, pixelated photos are transformed into
              crisp, high-definition masterpieces. This advanced image
              enhancement tool delivers stunning results with incredible speed.
            </p>
            <button className="try-button" onClick={goToNewPage}>
              <img src={rightArrow} alt="Icon" className="button-icon" />
              Try It Now
            </button>
            <img
              src={rightArrow1}
              alt="Scroll Right"
              className="right-arrow"
              onClick={() => scrollToNextColumn(1)}
            />
          </div>
        </div>

        <div className="column">
          <img src={AIImage1} alt="AIImage3" className="column-image" />
          <div className="column-content">
            <h2>Background Removal</h2>
            <p className="ai-paragraph">
              Seamlessly eliminate unwanted elements from your images, achieving
              professional-quality cutouts with precision. Ideal for product
              photography, e-commerce, and design projects.
            </p>
            <button className="try-button" onClick={goToNewPage}>
              <img src={rightArrow} alt="Icon" className="button-icon" />
              Try It Now
            </button>
            <img
              src={rightArrow1}
              alt="Scroll Right"
              className="right-arrow"
              onClick={() => scrollToNextColumn(2)}
            />
          </div>
        </div>

        <div className="column">
          <img src={AIImage1} alt="AIImage4" className="column-image" />
          <div className="column-content">
            <h2>Anime Generator</h2>
            <p className="ai-paragraph">
              Tap into your creativity and bring anime characters and scenes to
              life. Customize every aspect, from character design to intricate
              backgrounds, to craft unique and captivating visuals.
            </p>
            <button className="try-button" onClick={goToNewPage}>
              <img src={rightArrow} alt="Icon" className="button-icon" />
              Try It Now
            </button>
            <img
              src={rightArrow1}
              alt="Scroll Right"
              className="right-arrow"
              onClick={() => scrollToNextColumn(3)}
            />
          </div>
        </div>

        <div className="column">
          <img src={AIImage1} alt="AIImage5" className="column-image" />
          <div className="column-content">
            <h2>Logo Generator</h2>
            <p className="ai-paragraph">
              Tap into your creativity and bring anime characters and scenes to
              life. Customize every aspect, from character design to intricate
              backgrounds, to craft unique and captivating visuals.
            </p>
            <button className="try-button" onClick={goToNewPage}>
              <img src={rightArrow} alt="Icon" className="button-icon" />
              Try It Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AITools;
